var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { COLORS } from "../../../constants/colors";
export var dragAndDropSxPropsFn = function (_a) {
    var displayImageUrl = _a.displayImageUrl, size = _a.size, disabled = _a.disabled, circularCrop = _a.circularCrop;
    var dragAndDropStyles = {
        background: displayImageUrl ? "transparent" : COLORS.LIGHT_GREY,
        boxSizing: "border-box",
        borderRadius: circularCrop ? "50%" : 2,
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        position: "relative",
    };
    var sizeSpecificStyles = {};
    switch (size) {
        case "small":
            sizeSpecificStyles = {
                width: "100px",
                height: "100px",
            };
            break;
        case "medium":
            sizeSpecificStyles = {
                width: "120px",
                height: "120px",
            };
            break;
        case "large":
        default:
            sizeSpecificStyles = {
                width: "221px",
                height: "145px",
            };
    }
    var hoverStyles = {
        "&:hover": {
            ".image-upload-hover-cta": {
                opacity: "1",
            },
        },
    };
    var disabledStyles = {};
    if (disabled) {
        disabledStyles = {
            cursor: "default",
            ".MuiTypography-root": {
                color: COLORS.P_DISABLED,
            },
        };
    }
    return __assign(__assign(__assign(__assign({}, dragAndDropStyles), sizeSpecificStyles), hoverStyles), disabledStyles);
};
export var textStyles = {
    p: "2px 6px",
    marginTop: 2,
    border: "1px solid currentColor",
    borderRadius: 1,
    fontSize: "0.75rem", // 12px,
};
export var imageUploadCTAStyles = {
    height: "100%",
    width: "100%",
    opacity: "0",
    transition: "opacity 0.3s",
    background: COLORS.P_MED_EMPHASIS,
    boxSizing: "border-box",
    position: "absolute",
    top: "0",
    justifyContent: "center",
    alignItems: "center",
};
